'use client';

import {
  Flex,
  Image,
  Stack,
  Separator,
  AbsoluteCenter,
  type StackProps,
} from '@react/chakra';

import type { JSX } from 'react';

import { KofiImage } from '../Kofi';

export function DonationImage(props: StackProps): JSX.Element {
  return (
    <Stack gap={4} {...props}>
      <KofiImage />
      <Flex
        h='100px'
        w='160px'
        alignSelf='center'
        position='relative'
        justifyContent='center'
      >
        <Separator variant='dashed' orientation='vertical' />
        <AbsoluteCenter bgColor='gray.800' py={4}>
          Or
        </AbsoluteCenter>
      </Flex>
      <Image
        alt='momo-qr.webp'
        src='/momo-qr.webp'
        objectFit='contain'
        w={{
          base: '100%',
          md: 'unset',
        }}
        h={{
          base: 'unset',
          md: '500px',
        }}
      />
    </Stack>
  );
}
